export enum FeatureType {
  AUDIT_LOG = 'audit_log',
  PR_INSIGHTS = 'pr_insights'
}

export enum PlanTypes {
  STARTER = 'starter',
  BUSINESS = 'business',
  ENTERPRISE = 'enterprise'
}

export enum V2PlanTypes {
  OPEN_SOURCE = 'open_source',
  TRIAL = 'trial',
  TEAM = 'team',
  ENTERPRISE = 'enterprise'
}

export interface FeatureProperties {
  title: string
  description?: string
  minRequiredPlan?: PlanTypes
  minRequiredPlanV2?: V2PlanTypes
}

export const featureMap: Record<FeatureType, FeatureProperties> = {
  [FeatureType.AUDIT_LOG]: {
    title: 'Audit Log',
    minRequiredPlan: PlanTypes.BUSINESS, // This is used as the copy text
    minRequiredPlanV2: V2PlanTypes.TEAM
  },
  [FeatureType.PR_INSIGHTS]: {
    title: 'PR Insights',
    description:
      "PR insights provide structured feedback on the code's quality and security by connecting the dots between issues detected, so you or your AI coding agent can see the big picture.",
    minRequiredPlanV2: V2PlanTypes.TEAM
  }
}
